<template>
    <section>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <h1>Items</h1>
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col cols="12" md="auto">
                <div class="d-flex align-center">
                  <span class="mr-3 font-weight-medium grey--text text--darken-1">Show:</span>
                  <v-btn-toggle
                    v-model="deletedFilter"
                    mandatory
                    color="cyan darken-2"
                    class="elevation-2"
                  >
                    <v-btn value="all" text small class="px-4">
                      <v-icon small class="mr-1">visibility</v-icon>
                      All
                    </v-btn>
                    <v-btn value="exclude" text small class="px-4">
                      <v-icon small class="mr-1">check_circle</v-icon>
                      Active
                    </v-btn>
                    <v-btn value="only" text small class="px-4">
                      <v-icon small class="mr-1">delete</v-icon>
                      Deleted
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </v-col>
            </v-row>

            <v-row justify="space-between" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col cols="12" sm="12" md="3">
                <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
              </v-col>

              <v-col cols="12" md="4" class="d-flex justify-space-around">
                <div>
                  <v-tooltip top color="secondary">
                    <template v-slot:activator="{ on }">
                      <v-btn text large @click="updateDataTable" v-on="on">
                        <v-icon color="cyan darken-2">refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>Refresh</span>
                  </v-tooltip>
                </div>

                <div>
                  <v-tooltip top color="secondary">
                    <template v-slot:activator="{ on }">
                      <v-btn class="mx-2" fab dark color="blue lighten-1" v-on="on">
                        <v-icon @click="downloadSpreadsheet" dark>get_app</v-icon>
                      </v-btn>
                    </template>
                    <span>Download spreadsheet</span>
                  </v-tooltip>
                </div>

                <div>
                  <v-tooltip top color="secondary">
                    <template v-slot:activator="{ on }">
                      <v-btn v-if="isInventoryManager" class="mx-2" fab dark color="blue lighten-1" v-on="on">
                        <v-icon @click="newItem" dark>add</v-icon>
                      </v-btn>
                    </template>
                    <span>Create a new item</span>
                  </v-tooltip>
                </div>

              </v-col>

            </v-row>
          </v-container>

          <v-divider></v-divider>

          <v-data-table
            :search="search"
            :headers="headers"
            :items="renderedItems"
            :loading="loading"
          >
            <template v-slot:item="props">
              <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2, 'deleted-item': props.item.deleted}">
                <td v-if="header.text !== 'Actions' && header.value !== 'climate'" style="text-align: center" v-for="(header, index) in headers"
                    :key="index">{{props.item[header.value]}}
                  <v-chip
                    v-if="header.value === 'name' && props.item.deleted"
                    small
                    color="red lighten-2"
                    class="ml-2"
                  >
                    DELETED
                  </v-chip>
                </td>
                <td class="text-center">
                  {{props.item.climate.name}}
                </td>
                <td class="text-center" v-if="isInventoryManager">
                  <v-tooltip top color="secondary">
                    <template v-slot:activator="{ on }">
                      <v-icon @click="editRow(props.item)" color="blue" v-on="on">
                        edit
                      </v-icon>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>

                  <v-tooltip v-if="!props.item.deleted" top color="secondary">
                    <template v-slot:activator="{ on }">
                      <v-icon @click="deleteRow(props.item)" color="red" v-on="on" class="pl-1">
                        delete
                      </v-icon>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>

                  <v-tooltip v-if="props.item.deleted" top color="secondary">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        @click="restoreItem(props.item)"
                        color="green"
                        v-on="on"
                        class="pl-1"
                        :disabled="restoringItemId === props.item.id"
                      >
                        restore
                      </v-icon>
                    </template>
                    <span>Restore item</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>



    <v-dialog
      v-model="itemDialog"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <h3>{{editedIndex > -1 ? 'Edit item ' + editedItem.id : 'New item' }}</h3>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editedItem.name"
            label="Item name"
            prepend-icon="fas fa-box"
            required
          ></v-text-field>
          <v-text-field
            v-model="editedItem.sku"
            label="SKU"
            prepend-icon="receipt"
            :disabled="editedIndex > -1"
          ></v-text-field>
          <v-select
            label="Choose a climate"
            :items="climates"
            item-text="name"
            item-value="id"
            v-model="editedItem.climate"
            return-object
            prepend-icon="far fa-snowflake"
          ></v-select>
          <v-select
            v-if="isInternalUser"
            label="Choose a client"
            :items="clients"
            item-text="name"
            item-value="id"
            v-model="editedItem.client_id"
            prepend-icon="person"
          ></v-select>
          <v-text-field
            v-model="editedItem.serial"
            label="Item serial number"
            prepend-icon="local_mall"
          ></v-text-field>
          <v-select
            label="Whether or not this item must be FIFO"
            :items="YesOrNo"
            prepend-icon="fas fa-list-ol"
            v-model="editedItem.fifo"
          ></v-select>
          <v-text-field
            v-model="editedItem.description"
            label="Item description"
            prepend-icon="notes"
          ></v-text-field>
          <v-text-field
            v-model="editedItem.weight_g"
            label="weight g"
            prepend-icon="fas fa-weight"
          ></v-text-field>
          <v-autocomplete
            v-model="editedItem.sku_type"
            label="sku type"
            :items="sku_types"
            item-text="name"
            item-value="sku_type"
            prepend-icon="fas fa-box"
          >
            <template v-slot:item="{ item }">
              <div class="d-flex align-center justify-space-between" style="width: 100%">
                {{ item.name }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      size="24"
                      color="grey lighten-1"
                    >
                      info
                    </v-icon>
                  </template>
                  <span class="custom-tooltip-text">{{ item.description || 'No description available' }}</span>
                </v-tooltip>
              </div>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            text
            @click="closeItemDialog"
            color="blue-grey lighten-2"
          >Cancel</v-btn>
          <v-btn
            text
            @click="saveChanges"
            color="blue darken-1"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this item. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
          <v-btn text @click="DeleteItem" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="restoreDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>Confirm Restore</h3>
        </v-card-title>
        <v-card-text class="text-center">
          Are you sure you want to restore this item? It will become active again.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeRestored=null; restoreDialog=false" color="blue-grey lighten-2">Cancel</v-btn>
          <v-btn text @click="RestoreItem" color="blue darken-1">Yes, Restore</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </section>

</template>

<script>
    import axios from 'axios';
    import Excel from 'exceljs/dist/exceljs';
    import {saveAs} from "file-saver";

    export default {
        name: "ItemsDataTable",
        data() {
            return {
                search: '',
                loading: false,
                reload: false,
                timer: '',
                deletedFilter: 'exclude',
                restoringItemId: null,
                restoreDialog: false,
                toBeRestored: null,
                // headers: [
                //     {text: 'Id', value: 'id', align: 'center', sortable: true},
                //     {text: 'Client name', value: 'client_name', align: 'center', sortable: true},
                //     {text: 'SKU', value: 'sku', align: 'center', sortable: true},
                //     {text: 'Name of item', value: 'name', align: 'center', sortable: false},
                //     {text: 'Climate', value: 'climate', align: 'center', sortable: false},
                //     {text: 'Actions', value: 'actions', align: 'center', sortable: false}
                // ],
                YesOrNo: [
                    {text: "Yes", value: true},
                    {text: "No", value: false},
                ],
                itemDialog: false,
                editedIndex: -1,
                toBeDeleted: null,
                deleteDialog: false,
                climates: null,
                clients: null,
                editedItem: {
                    sku: null,
                    name: null,
                    description: null,
                    serial: null,
                    climate : {
                        id: null,
                        name: null,
                        temp: null
                    },
                    fifo: null,
                    client_id: null,
                    weight_g:0,
                    sku_type:null
                },
                default: {
                    sku: null,
                    name: null,
                    description: null,
                    serial: null,
                    climate : {
                        id: null,
                        name: null,
                        temp: null
                    },
                    fifo: null,
                    client_id: null,
                    weight_g:0,
                    sku_type:null
                },
                sku_types: []
            }
        },
        mounted: function () {
            this.timer = setInterval(() => {
                this.reload = !this.reload;
            }, 300000);
            this.getClimates();
            this.getSkuTypes();
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
        computed: {
            headers() {
                let headers = [
                    {text: 'Id', value: 'id', align: 'center', sortable: true},
                    {text: 'SKU', value: 'sku', align: 'center', sortable: true},
                    {text: 'Name of item', value: 'name', align: 'center', sortable: false},
                    {text: 'Climate', value: 'climate', align: 'center', sortable: false},
                    {text: 'Actions', value: 'actions', align: 'center', sortable: false}
                ];
                if (this.isInternalUser) {
                    headers.unshift({text: 'Client name', value: 'client_name', align: 'center', sortable: false});
                }
                return headers;
            },
            renderedItems() {
                if (this.ListItems === null || this.ListItems === undefined) {
                    return [];
                } else {
                    return this.ListItems;
                }
            },
        },
        watch: {
            deletedFilter() {
                this.reload = !this.reload;
            }
        },
        asyncComputed: {
            async ListItems() {
                if (this.reload || !this.reload) {
                    this.loading = true;
                    const url = process.env.API_URL + '/items?deleted=' + this.deletedFilter;
                    return await axios.get(url)
                        .then((response) => {
                            if (response.status === 200) {
                                this.loading = false;
                                return response.data;
                            } else {
                                this.loading = false;
                                return [];
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            return [];
                        });
                }
            },
        },
        methods: {
            isInternalUser() {
                return this.$store.getters['auth/isInternalUser'];
            },
            isInventoryManager(){
                return this.$store.getters['auth/inventory_manage'];
            },
            updateDataTable() {
                this.reload = !this.reload;
            },
            newItem() {
                this.editedIndex = -1;
                this.editedItem = Object.assign({}, this.default);
                this.itemDialog = true;
                this.getSkuTypes();
                if (this.isInternalUser()){
                    this.getClients();
                }
            },
            editRow(item) {
                this.editedItem = Object.assign({}, item);
                this.editedIndex = this.ListItems.indexOf(item);
                this.itemDialog = true;
                this.getClimates();
                this.getSkuTypes();
                if (this.isInternalUser()){
                    this.getClients();
                }
            },
            deleteRow(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            restoreItem(item) {
                this.toBeRestored = item;
                this.restoreDialog = true;
            },
            RestoreItem() {
                this.restoringItemId = this.toBeRestored.id;

                axios.patch(process.env.API_URL + '/items/' + this.toBeRestored.id + '/restore')
                    .then((response) => {
                        this.toBeRestored = null;
                        this.restoreDialog = false;
                        this.restoringItemId = null;
                        this.$store.commit('displaySnackbar', 'Item restored successfully');
                        this.updateDataTable();
                    })
                    .catch((error) => {
                        this.restoringItemId = null;
                        const errorMsg = (error.response && error.response.data && error.response.data.error) || 'Restore failed';
                        this.$store.commit('displaySnackbar', 'ERROR: ' + errorMsg);
                        this.updateDataTable();
                    });
            },
            closeItemDialog() {
                this.editedItem = Object.assign({}, this.default);
                this.itemDialog = false;
            },
            saveChanges() {
                let body = {
                    sku: this.editedItem.sku,
                    name: this.editedItem.name,
                    description: this.editedItem.description,
                    serial: this.editedItem.serial,
                    client_id: this.editedItem.client_id,
                    climate_id: this.editedItem.climate.id,
                    fifo: this.editedItem.fifo,
                    weight_g:this.editedItem.weight_g,
                    sku_type:this.editedItem.sku_type
                };
                if (this.editedIndex > -1) {
                    // EDIT
                    axios.put(process.env.API_URL + '/items/' + this.editedItem.id, body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar','Changes saved');
                            this.updateDataTable();
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + error.response.data.error);
                        });
                } else {
                    // CREATE
                    if (body.name === null) {
                        this.$store.commit('displaySnackbar','Please enter a name');
                        return false;
                    }

                    axios.post(process.env.API_URL + '/items', body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar','Create successful');
                            this.updateDataTable();
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar','ERROR: Create failed ' + error.response.data.error);
                        });
                }
                this.closeItemDialog();
                this.updateDataTable();
            },
            DeleteItem() {
                axios.delete(process.env.API_URL + '/items/' + this.toBeDeleted.id)
                    .then((response) => {
                        this.toBeDeleted = null;
                        this.deleteDialog = false;
                        this.$store.commit('displaySnackbar','Delete successful');
                        this.updateDataTable();
                    })
                    .catch((error) => {
                        this.$store.commit('displaySnackbar','ERROR: Delete failed');
                    });
                this.updateDataTable();
            },
            // @vuese
            // Gets all the climates
            getClimates() {
                axios.get(process.env.API_URL + '/climates')
                    .then((response) => {
                        this.climates = response.data;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Gets all the SKU types
            getSkuTypes() {
                axios.get(process.env.API_URL + '/items/sku-types')
                    .then((response) => {
                        this.sku_types = response.data.sku_types;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Gets all the clients
            getClients() {
                axios.get(process.env.API_URL + '/clients?active=true')
                    .then((response) => {
                        this.clients = Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            downloadSpreadsheet(){
              axios.get(process.env.API_URL + '/items')
                .then((response) => {
                  console.log(response.data);
                  const workbook = new Excel.Workbook();
                  const worksheet = workbook.addWorksheet("Items list");

                  worksheet.columns = [
                    {header: 'Client', key: 'client', width: 30},
                    {header: 'Sku', key: 'sku', width: 30},
                    {header: 'Name of item', key: 'name', width: 30},
                    {header: 'Climate', key: 'climate', width: 20},
                    {header: 'Temperature', key: 'temp', width: 20},
                  ];

                  response.data.forEach( focusedIem => {
                    worksheet.addRow({
                      client: focusedIem.client_name,
                      sku: focusedIem.sku,
                      name: focusedIem.name,
                      climate: focusedIem.climate.name,
                      temp: focusedIem.climate.temp
                    });
                  });

                  workbook.xlsx.writeBuffer()
                    .then( data => {
                      const blob = new Blob( [data], { type: 'application/octet-stream'} );
                      saveAs( blob, "Items list.xlsx");
                    });
                })
                .catch((response) => {
                  console.log(response);
                  this.$store.commit('displaySnackbar', 'ERROR ' + response);
                })
            }
        }
    }
</script>

<style scoped>

  /* Make all v-tooltip popover content darker and text bigger */
  .v-tooltip__content {
    background-color: #222 !important;
    color: #fff !important;
  }
  .custom-tooltip-text {
    font-size: 1.05em;
    font-weight: 500;
  }

  /* Add blue bottom border to active filter button */
  .v-btn-toggle >>> .v-btn--active {
    box-shadow: 0 3px 0 0 #2196F3 !important;
  }
  .deleted-item {
    background-color: #ffebee !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/util/Inventory/ItemsDataTable.vue